export default "__VITE_ASSET__DVtSzUlt__"